import type { monaco } from 'react-monaco-editor';

const builtinConstants = 'true|false';

const builtinFunctions =
  'avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|' +
  'coalesce|ifnull|isnull|nvl';

const keywords =
  'select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|' +
  'when|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|' +
  'foreign|not|references|default|null|inner|cross|natural|database|drop|grant';

const dataTypes =
  'int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|interval|' +
  'money|real|number|integer';

const registerCompletions = (monacoInstance: typeof monaco) => {
  const registration = monacoInstance.languages.registerCompletionItemProvider('sql', {
    provideCompletionItems() {
      return {
        suggestions: [
          ...builtinConstants.split('|').map(constant => ({
            label: constant,
            detail: 'constant',
            kind: monacoInstance.languages.CompletionItemKind.Constant,
            insertText: constant,
          })),
          ...keywords.split('|').map(keyword => ({
            label: keyword,
            detail: 'keyword',
            kind: monacoInstance.languages.CompletionItemKind.Keyword,
            insertText: keyword,
          })),
          ...dataTypes.split('|').map(datatype => ({
            label: datatype,
            detail: 'datatype',
            kind: monacoInstance.languages.CompletionItemKind.Text,
            insertText: datatype,
          })),

          ...builtinFunctions.split('|').map(func => ({
            label: func,
            detail: 'function',
            kind: monacoInstance.languages.CompletionItemKind.Function,
            insertText: `${func}()`,
          })),
        ] as monaco.languages.CompletionItem[],
      };
    },
  });

  return registration;
};

export default registerCompletions;
